import { devtools } from "zustand/middleware";
import { shallow } from "zustand/shallow";
import { createWithEqualityFn } from "zustand/traditional";

interface IDialogWindowStore {
  isOpen: boolean;
  isDialogWindowOpen: boolean;
  setIsDialogWindowOpen: (isDialogWindowOpen: boolean) => void;
  setIsOpen: (isOpen: boolean) => void;
}

export const useDialogWindowStore = createWithEqualityFn<IDialogWindowStore>()(
  devtools(
    (set) => ({
      isOpen: false,
      isDialogWindowOpen: false,
      setIsOpen: (isOpen) => {
        set({ isOpen });
      },
      setIsDialogWindowOpen: (isDialogWindowOpen) => {
        set({ isDialogWindowOpen });
      },
    }),
    { name: "DialogWindowStore" },
  ),
  shallow,
);
